import LinkedAssociationEmptyState from './LinkedAssociationEmptyState.component';

export default LinkedAssociationEmptyState;